// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".splash-testimonial__inner[data-v-6f1b14fa]{grid-template-columns:1fr auto}.splash-testimonial__quote[data-v-6f1b14fa]:after{content:\"“\";font-size:140px;font-weight:700;left:-2.75rem;line-height:1;opacity:.1;position:absolute;top:-2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
